import type { SVGAttributes } from 'react';
import type { ChakraProps } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';

const Svg = chakra('svg');

type Props = Omit<SVGAttributes<SVGElement>, keyof ChakraProps> & ChakraProps;

export const TopBannerIllustration = (props: Props) => (
  <Svg width={1499} height={97} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#a)'>
      <path
        d='M1265.21 34.813 1559-219H-61L152.516-5.484c98.022 98.022 256.946 98.022 354.968 0l9.786-9.786c90.236-90.236 234.626-96.095 331.876-13.467l76.443 64.949c98.071 83.325 242.241 82.731 339.621-1.4Z'
        fill='#EDF5F7'
      />
      <circle r={9} transform='matrix(-1 0 0 1 657 46)' fill='#50B2C2' />
      <circle r={205.25} transform='matrix(-1 0 0 1 967 -121)' stroke='#BDDEE1' strokeWidth={1.5} />
      <circle
        r={170.75}
        transform='matrix(-1 0 0 1 480.5 -113.5)'
        stroke='#E9BC9B'
        strokeWidth={1.5}
      />
      <circle r={18} transform='matrix(-1 0 0 1 1358 61)' fill='#E58F38' />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' transform='matrix(-1 0 0 1 1499 0)' d='M0 0h1499v97H0z' />
      </clipPath>
    </defs>
  </Svg>
);
